import { queryClient } from "@verbleif/lib/src/composables/Query/queryClient";
import { itemKey } from "./resourceKeys";

export async function invalidateResources(keys: readonly { root: readonly unknown[] }[]): Promise<void> {
  await Promise.all(keys.map(key => queryClient.invalidateQueries({ queryKey: key.root })));
}

export async function invalidateResource(keys: { root: readonly unknown[] }, iri?: string): Promise<void> {
  await queryClient.invalidateQueries({ queryKey: keys.root });
  if (iri) {
    await queryClient.invalidateQueries({ queryKey: itemKey(iri) });
  }
}
